<template>
  <div
    class="message cr-br-large"
    :class="`message--${role}`"
    :style="{ backgroundColor: role === 'assistant' ? assistantChatColor : userMessageColor }"
  >
    <div
      v-if="role === 'user'"
      class="cr-flex cr-align-center gap-2"
    >
      <BaseAvatar
        background-color="var(--pepper-700)"
        class="cr-font-roboto-flex cr-align-self-start"
        :contact="contact"
        size="small"
        text-color="var(--salt)"
      />
      <span class="body-m-regular message__content">
        {{ content }}
      </span>
    </div>
    <template v-else-if="role === 'assistant'">
      <div class="cr-spc-my-2 cr-flex cr-flex-col gap-2">
        <ClientHomePageChatMessageMarkdown
          class="body-m-regular"
          :html="content"
        />
        <ClientHomePageChatWidget
          v-for="component in components"
          :key="component.id"
          :component-data="getComponentData(component)"
          :component-name="getComponentName(component)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import ClientHomePageChatMessageMarkdown from './ClientHomePageChatMessageMarkdown.vue'
import BaseAvatar from './BaseAvatar.vue'
import ClientHomePageChatWidget from './ClientHomePageChatWidget.vue'

export default {
  name: 'ClientHomePageChatMessage',
  components: {
    ClientHomePageChatMessageMarkdown,
    BaseAvatar,
    ClientHomePageChatWidget,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    assistantChatColor: {
      type: String,
      default: 'var(--salt)',
    },
    userMessageColor: {
      type: String,
      default: 'var(--candy-wrapper-200)',
    },
    externalUserFullName: {
      type: String,
      required: true,
    },
    components: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    firstName() {
      return this.externalUserFullName.split(' ')[0] ?? ''
    },
    lastName() {
      return this.externalUserFullName.split(' ')[1] ?? ''
    },
    contact() {
      return { first_name: this.firstName, last_name: this.lastName }
    },
  },
  methods: {
    getComponentData(component) {
      return component?.getRecord()?.component_data
    },
    getComponentName(component) {
      return component?.getRecord()?.component_name
    },
  },
}
</script>

<style lang="scss" scoped>
.message {
  display: flex;

  :deep(p) {
    margin: 0;
  }

  &--user {
    align-self: flex-start;
    padding: var(--space-2) var(--space-3) var(--space-2) var(--space-2);
  }

  &--assistant {
    display: block;
    padding: var(--space-4)
  }

  &__content {
    word-break: break-word;
  }
}
</style>
